import { createSelector } from "reselect";
import get from "lodash/get";

const dealById = createSelector(
  state => state,
  (_, dealId) => dealId,
  (state, dealId) => get(state, ["deal", dealId], null)
);

export default dealById;
